import React, {useMemo, useState} from "react";
import { observer } from "mobx-react";
import { useRequiredStore } from "../../../../../utils/store";
import { AgentDataStoreContext } from "../../agent.data.store";
import {useTranslate} from "../../../../../hooks/translate.hook";
import FilteredTable from "../../../../common/filtered-table/filtered.table";
import { ComponentPropsFromRoute } from "../../../../../routers/routers";
import {Alert, Button, Dropdown, Menu, Row, Space} from "antd";
import {FilterDataHandler} from "../../../../../models/filter/filter.data.handler";
import {columnsFactory} from "./agent.data.credit-invoices.columns";
import {convertTableColumnsToColumnConfigs} from "../../../../../utils/table";
import {filtersFactory} from "./agent.data.credit-invoices.filters";
import {creditInvoicesService} from "../../../../../services/documents/invoices/credit.invoices.service";
import {CreditInvoice} from "../../../../../models/documents/invoices/credit-invoice/credit.invoice";
import {PDFModal} from "../pdf-modal/pdf.modal";
import {TableRowSelection} from "antd/lib/table/interface";
import {RootStoreContext} from "../../../../../stores/root/root.store";

interface AgentDataCreditInvoicesProps extends ComponentPropsFromRoute {
}

export const AgentDataCreditInvoices: React.FC<AgentDataCreditInvoicesProps> =
    observer(({ name }) => {
        const agentDataStore = useRequiredStore(AgentDataStoreContext);

        const t = useTranslate();

        const {
            authStore: { generateUri },
        } = useRequiredStore(RootStoreContext);

        const dataHandler = useMemo(
            () =>
                new FilterDataHandler<CreditInvoice>((request) =>
                    creditInvoicesService.getAllByAccount(
                        request,
                        String(agentDataStore.account!.id)
                    )
                ),
            []
        );

        const columns = useMemo(() => columnsFactory(t, generateUri), []);
        const filters = useMemo(() => filtersFactory(t), []);

        const [exportAsPDFModalShown, setExportAsPDFModalShown] = useState<boolean>(false);
        const [selectedDocs, setSelectedDocs] = useState<any[]>([]);

        const rowSelection: TableRowSelection<CreditInvoice> = {
            preserveSelectedRowKeys: true,
            type: "checkbox",
            selectedRowKeys: selectedDocs,
            onChange: (selectedRowKeys: React.Key[], selectedRows: CreditInvoice[]) => {
                setSelectedDocs(selectedRowKeys)
            },
        };

        return (
            <Space direction="vertical" size={[10, 10]}>
                <Row justify={"end"}>
                    <Dropdown
                        trigger={["click"]}
                        overlay={
                            <Menu>
                                <Menu.Item
                                    key={0}
                                    onClick={() => setExportAsPDFModalShown(true)}
                                >
                                    {t('DOCUMENTS.EXPORT.AS_PDF')}
                                </Menu.Item>
                            </Menu>
                        }
                    >
                        <Button type={"primary"}>
                            {t("ACTION")}
                        </Button>
                    </Dropdown>
                </Row>

                <Alert
                    message={t("INVOICES.MERGED_INVOICE.LENGTH") + ": " + selectedDocs.length}
                    type="info"
                />

                <FilteredTable
                    columns={columns}
                    columnsConfigs={{ columns: convertTableColumnsToColumnConfigs(columns), pageKey: name }}
                    filterKeys={filters}
                    dataHandler={dataHandler}
                    rowSelection={rowSelection}
                />
                {exportAsPDFModalShown ? (
                    <PDFModal
                        onClose={() => setExportAsPDFModalShown(false)}
                        accountId={agentDataStore.account!.id}
                        selectedDocs={selectedDocs}
                        type={"credit_invoice"}
                    />
                ) : null}
            </Space>
        );
    });
